import { EmptyMenuPropsFactory, IMenuProps } from '@/entities/Menu'

export const mains: IMenuProps[] = [
  EmptyMenuPropsFactory({
    id: 'user',
    title: '担当リスト',
    icon: 'icon-user-card.svg'
  }),
  EmptyMenuPropsFactory({
    id: 'appointment',
    title: 'アポ管理',
    icon: 'icon-calendar.svg',
    notify: true,
    policy: ['admin', 'user']
  }),
  EmptyMenuPropsFactory({
    id: 'room',
    title: 'メッセージ',
    icon: 'icon-message.svg',
    notify: true,
    policy: ['admin', 'user']
  }),
  EmptyMenuPropsFactory({
    id: 'admission',
    title: '出入時刻',
    icon: 'icon-clock.svg',
    policy: ['admin', 'superuser', 'guard']
  }),
  EmptyMenuPropsFactory({
    id: 'schedule',
    title: '訪問予定/結果',
    icon: 'icon-appointment.svg',
    notice: true,
    policy: ['admin', 'superuser', 'guard']
  }),
  EmptyMenuPropsFactory({
    id: 'message',
    title: '一斉通知',
    icon: 'icon-bell2.svg',
    policy: ['admin', 'superuser']
  }),
  EmptyMenuPropsFactory({
    id: 'doctor',
    title: '病院職員管理',
    icon: 'icon-hospital-solid.svg',
    policy: ['admin', 'superuser']
  })
]

export const subs: IMenuProps[] = [
  EmptyMenuPropsFactory({
    id: 'notice',
    title: '運営からのお知らせ',
    icon: 'icon-info.svg',
    arrival: true
  }),
  EmptyMenuPropsFactory({
    id: 'company',
    title: '当院の未登録',
    icon: 'icon-check-book.svg',
    marker: true,
    policy: ['admin', 'superuser']
  }),
  EmptyMenuPropsFactory({
    id: 'report',
    title: 'レポート',
    icon: 'icon-bar-chart.svg',
    policy: ['admin', 'superuser']
  }),
  EmptyMenuPropsFactory({
    id: 'download',
    title: 'CSVダウンロード',
    icon: 'icon-download.svg'
  }),
  EmptyMenuPropsFactory({
    id: 'manual',
    title: '使い方 / マニュアル',
    icon: 'icon-question.svg',
    href: 'https://media.monitaro.jp/assets/マニュアル_病院職員用.pdf',
    target: '_blank'
  })
]

export const accounts: IMenuProps[] = [
  EmptyMenuPropsFactory({
    id: 'account-hospital',
    title: '担当病院の変更',
    icon: 'icon-hospital-solid.svg'
  }),
  EmptyMenuPropsFactory({
    id: 'account-superuser',
    title: '表示病院の変更',
    icon: 'icon-hospital-solid.svg'
  }),
  EmptyMenuPropsFactory({
    id: 'account',
    title: 'プロフィールの変更',
    icon: 'icon-circle-user-solid.svg'
  }),
  EmptyMenuPropsFactory({
    id: 'account-email',
    title: 'メールアドレスの変更',
    icon: 'icon-envelope-regular.svg'
  }),
  EmptyMenuPropsFactory({
    id: 'account-password',
    title: 'パスワードの変更',
    icon: 'icon-lock-solid.svg'
  }),
  EmptyMenuPropsFactory({
    id: 'logout',
    title: 'ログアウト',
    icon: 'icon-logout.svg'
  })
]

export const bottom: IMenuProps[] = [
  EmptyMenuPropsFactory({
    id: 'notice',
    title: 'ホーム',
    icon: 'icon-home.svg'
  }),
  EmptyMenuPropsFactory({
    id: 'room',
    title: 'メッセージ',
    icon: 'icon-message.svg'
  }),
  EmptyMenuPropsFactory({
    id: 'appointment',
    title: 'アポイント',
    icon: 'icon-calendar.svg'
  }),
  EmptyMenuPropsFactory({
    id: 'menu',
    title: 'メニュー',
    icon: 'icon-bars-sharp-solid.svg'
  })
]

/**
 * メニュー等には使わないがページとして存在するものを定義
 */
export const used: IMenuProps[] = [
  EmptyMenuPropsFactory({
    id: 'login',
    title: '病院管理者向けログイン'
  }),
  EmptyMenuPropsFactory({
    id: 'logout',
    title: 'ログアウト'
  }),
  EmptyMenuPropsFactory({
    id: 'forget',
    title: 'パスワードの再発行'
  }),
  EmptyMenuPropsFactory({
    id: 'config',
    title: '設定'
  }),
  EmptyMenuPropsFactory({
    id: 'user-id',
    title: '担当リスト'
  }),
  EmptyMenuPropsFactory({
    id: 'user-id-schedule',
    title: '担当リスト'
  }),
  EmptyMenuPropsFactory({
    id: 'user-id-result',
    title: '担当リスト'
  }),
  EmptyMenuPropsFactory({
    id: 'appointment-add',
    title: 'MRへの面談依頼'
  }),
  EmptyMenuPropsFactory({
    id: 'appointment-id-edit',
    title: 'MRへの面談依頼の再調整'
  }),
  EmptyMenuPropsFactory({
    id: 'appointment-id',
    title: 'アポイント申請内容'
  }),
  EmptyMenuPropsFactory({
    id: 'appointment-calendar',
    title: 'カレンダー'
  }),
  EmptyMenuPropsFactory({
    id: 'appointment-config',
    title: '面会設定'
  }),
  EmptyMenuPropsFactory({
    id: 'appointment-config-calendar',
    title: '外部カレンダー連携'
  }),
  EmptyMenuPropsFactory({
    id: 'notice-id',
    title: '運営からのお知らせ'
  }),
  EmptyMenuPropsFactory({
    id: 'schedule-id',
    title: '訪問予定/結果',
    policy: ['admin', 'superuser', 'guard']
  }),
  EmptyMenuPropsFactory({
    id: 'message-id',
    title: '一斉通知',
    policy: ['admin', 'superuser']
  }),
  EmptyMenuPropsFactory({
    id: 'doctor-id',
    title: '病院職員管理',
    policy: ['admin', 'superuser']
  }),
  EmptyMenuPropsFactory({
    id: 'doctor-division',
    title: '部署名管理',
    policy: ['admin', 'superuser']
  }),
  EmptyMenuPropsFactory({
    id: 'doctor-division-id',
    title: '部署名管理',
    policy: ['admin', 'superuser']
  }),
  EmptyMenuPropsFactory({
    id: 'room-id',
    title: 'メッセージ',
    policy: ['admin', 'user']
  }),
  EmptyMenuPropsFactory({
    id: 'room-id-config',
    title: 'メッセージ',
    notify: true,
    policy: ['admin', 'user']
  }),
  EmptyMenuPropsFactory({
    id: 'report-annual',
    title: 'レポート'
  }),
  EmptyMenuPropsFactory({
    id: 'report-monthly',
    title: 'レポート'
  })
]

const all = mains.concat(subs).concat(accounts).concat(used)

export default all
